import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShipmentsComponent } from '@app/features/shipments/shipments/shipments.component';
import { AddShipmentComponent } from '@app/features/shipments/add-shipment/add-shipment.component';
import { ViewShipmentComponent } from '@app/features/shipments/view-shipment/view-shipment.component';
import { EditShipmentComponent } from '@app/features/shipments/edit-shipment/edit-shipment.component';

const routes: Routes = [
  { path: '', component: ShipmentsComponent },
  { path: 'add', component: AddShipmentComponent },
  { path: ':shipmentId/edit', component: EditShipmentComponent },
  { path: ':shipmentId', component: ViewShipmentComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShipmentsRoutingModule { }
